import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { FilterState } from '../../providers/filter_state';

@Component({
  selector: 'filtres',
  templateUrl: 'filtres.html'
})
export class FiltresComponent implements OnInit {

  public venda : boolean;
  public lloguer : boolean;
  public nau : boolean;
  public parcela : boolean;
  public llistatFiltres : any;

  @Input() rebreLlistatFiltres : any;
  @Output() checkers = new EventEmitter();

  constructor(private filterState: FilterState) { }

  ngOnInit () {

    this.venda = this.filterState.venda;
    this.lloguer = this.filterState.lloguer;
    this.nau = this.filterState.nau;
    this.parcela = this.filterState.parcela;
    
    /*
    this.venda = this.inArray("Venda", this.rebreLlistatFiltres.regim);
    this.lloguer = this.inArray("Lloguer", this.rebreLlistatFiltres.regim);
    this.nau = this.inArray("Nau", this.rebreLlistatFiltres.tipologia);
    this.parcela = this.inArray("Parcel·la", this.rebreLlistatFiltres.tipologia);
    */
  }

  inArray (value, array) {
    return array.indexOf(value) != -1;
  }

  emitLlistatFiltres() {
    this.llistatFiltres = {
      regim: [],
      tipologia: []
    }

    this.venda ? this.llistatFiltres.regim.push("Venda") : null;
    this.lloguer ? this.llistatFiltres.regim.push("Lloguer") : null;
    this.nau ? this.llistatFiltres.tipologia.push("Nau") : null;
    this.parcela ? this.llistatFiltres.tipologia.push("Parcel·la") : null;

    this.filterState.venda = this.venda;
    this.filterState.lloguer = this.lloguer;
    this.filterState.nau = this.nau;
    this.filterState.parcela = this.parcela;    

    this.checkers.emit({
      value: this.llistatFiltres
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/filtres/filtres.ts